package com.example.mystybag.sharedmodels.project.requestModels

import com.example.mystybag.sharedmodels.AllCommands.CREATE_ENROLL
import com.example.mystybag.sharedmodels.base.BaseRequestModel
import com.example.mystybag.sharedmodels.mobileAdmin.database.UsersCredentialTypes
import kotlinx.serialization.Serializable

@Serializable
data class EnrollUserRequestModel(
    val email               : String                =   "",
    val credentialTypes     : UsersCredentialTypes  =   UsersCredentialTypes.STANDARD,
    val cityId              : Long                  =   0L,
    /** Optional profile data forwarded from social sign-in (e.g. Google). */
    val firstName           : String?               =   null,
    val lastName            : String?               =   null,
    val photoUrl            : String?               =   null,
    /** Partner referral code captured from an incoming deep link (optional). */
    val referralCode        : String                =   "",
    /** Free-text source/channel for attribution (optional). */
    val source              : String                =   "",
): BaseRequestModel(api = CREATE_ENROLL)
